import { atom } from 'recoil'

export type ImageProps = {
  uri: string
  description: string
  type?: 'imagem' | 'video' | 'audio' | 'documento'
  mimeType?: string
  message?: string
}

export const selectedOsImageViewState = atom<ImageProps>({
  key: 'selectedOsImageViewState',
  default: null as unknown as ImageProps
})
